import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const announcementStart = (accessToken, data) => baseAction.actionStart(actionTypes.ANNOUNCEMENT_START, accessToken, data);
export const announcementSuccess = (data) => baseAction.actionSuccess(actionTypes.ANNOUNCEMENT_SUCCESS, data);
export const announcementFail = (error) => baseAction.actionFail(actionTypes.ANNOUNCEMENT_FAIL, error);

export const announcementSelect = (options) => {
    return (dispatch, getState) => {  
        if (options && options.announcementId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/Announcements/${options.announcementId}`,
                startFn: (accessToken) => dispatch(announcementStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(announcementSuccess({ announcement: response.data, isNew: false })),
                failFn: (error) => dispatch(announcementFail(error))
            });
        } else {
            dispatch(announcementSuccess({ announcement: null, isNew: true }));
        }
    };
};

export const announcementList = () => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: '/Announcements',
            startFn: (accessToken) => dispatch(announcementStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(announcementSuccess({ announcements: response.data })),
            failFn: (error) => dispatch(announcementFail(error))
        });
    };
};

export const announcementCreate = (options) => {
    return (dispatch, getState) => {
        let { file, ...rest } = options.data;

        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            multiPart: true,
            files: [file],
            url: '/Announcements',
            payload: rest,
            startFn: (accessToken) => dispatch(announcementStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(announcementSuccess({ announcement: response.data, isNew: false })),
            failFn: (error) => dispatch(announcementFail(error))
        });
    };
};

export const announcementUpdate = (options) => {  
    return (dispatch, getState) => {
        let { file, ...rest } = options.data;

        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            multiPart: true,
            files: (file) ? [file] : null,
            url: `/Announcements/${options.announcementId}`,
            payload: rest,
            startFn: (accessToken) => dispatch(announcementStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(announcementSuccess({ announcement: response.data, isNew: false })),
            failFn: (error) => dispatch(announcementFail(error))
        });
    };
};

export const announcementDelete = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: `/Announcements/${options.announcementId}`,
            startFn: (accessToken) => dispatch(announcementStart(accessToken, { lastScope: 'delete' })),
            successFn: (response) => dispatch(announcementSuccess({ announcement: null, isNew: false })),
            failFn: (error) => dispatch(announcementFail(error))      
        });
    };
};
